import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

interface ModalHasOpenTransitionLocationState {
  ModalHasOpenTransition?: boolean
}

export const useModalHasOpenTransition = () => {
  const location = useLocation<
    ModalHasOpenTransitionLocationState | undefined
  >()

  const hasOpenTransition = useMemo(() => {
    return Boolean(location?.state?.ModalHasOpenTransition)
  }, [location.state?.ModalHasOpenTransition])

  return { hasOpenTransition }
}
